import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-pigmy-monthly-transfer',
  templateUrl: './pigmy-monthly-transfer.component.html',
  styleUrls: ['./pigmy-monthly-transfer.component.css']
})
export class PigmyMonthlyTransferComponent implements OnInit {

  title="Pigmy Monthly Transfer";
  p:any={};
  c:any={};
  data: any=[];
  branchlist: any=[];
  schemeagentslist: any=[];
  accountTypelist: any=[];
  agentcollectiondetailslist: any=[];
  dailycollectiondetailslist:any=[];
  d:any={};
  DateValues : string;
  Ball:any;
  TotalDailycollection:any=0;
  logbranch:any;
  modid_pvt:any;
  getmodata: any;
  transfrdata: any;
  txtPerc:any=3;
  txtPercLn  :any=2.5;
  today = new Date();  
  transdateee:Date;


  constructor(private service: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private datepipe: DatePipe)
   {
    
    }

  ngOnInit() {

    
    //this.getmodid_pvt("frmPigmyAgentDetail");
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.GetAllBranches(); 
    this.GetAllAccountTypes();
    //this.GetScheme(this.c.BRANCH_ID);
    this.GetDepositCommsission();
    this.GetScheme(this.logbranch);
    this.c.DepositCommission=3;//this.txtPerc;
    //this.txtPercLn = 2.5
    this.c.TransDate=this.getdatefun(this.today);
    this.c.CollectionDate=this.getdatefun(this.today);
    //this.c.OPtremittance.value="Remittance";
    this.c.BRANCH_ID=this.logbranch;
    
  }
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datepipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }


  getmodid_pvt(frmname:string)
  {
    this.getmodata=this.service.getservicemod(frmname,'empty');
    this.getmodata.subscribe(
      (respon:any)=>
      {
        debugger;
        this.modid_pvt=respon;
        console.log(this.modid_pvt);
      }
    )
  }

//Branch dropdown
  GetAllBranches() {
    debugger;
      this.data = this.service.getAllBranches();
      this.data.subscribe(
        (response:any) => {
          this.branchlist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  //DepositCommsission
  GetDepositCommsission() {
    debugger;
      this.data = this.service.getDepositCommsission();
      this.data.subscribe(
        (response:any) => {
         // this.c.DepositCommission = response;
          console.log(this.c.DepositCommission);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

//Scheme dropdown
  GetScheme(branchId)
  {
    this.data = this.service.getSchemeForMonthlyTransfer(branchId);
    this.data.subscribe(
      (response: any) => {
        this.schemeagentslist = response;
        console.log(this.schemeagentslist);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

//adjust to dropdown
  GetAllAccountTypes()
  {
    this.data = this.service.getAllAccountTypes();
    this.data.subscribe(
      (response: any) => {
        this.accountTypelist = response;
        console.log(this.accountTypelist);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
      
  }

  //1st grid

  GetAgentCollectionDetailsGrid(agentId,trans_Date,collectionDate,OPtremittance,depint)
  {
    debugger;
    var toatl=0,bal=0,paid=0,LBLADJAMT=0,txtamt=0;
    // if(trans_Date!=null)
    // trans_Date=((trans_Date).split('T'))[0];
    // if(collectionDate!=null)
    // collectionDate=((collectionDate).split('T'))[0];
    //trans_Date = this.datepipe.transform(trans_Date,'yyyy-mm-dd');
   // collectionDate = this.datepipe.transform(collectionDate,'yyyy-mm-dd');


    var date = new Date();
   console.log(this.datepipe.transform(trans_Date,"yyyy-MM-dd"));

  // trans_Date =this.datepipe.transform(trans_Date,"yyyy-MM-dd");
 //  collectionDate =this.datepipe.transform(collectionDate,"yyyy-MM-dd")

//  this.c.TransDate.value.Photo=this.getPhotoUrl();

//    trans_Date.value=trans_Date;
//    collectionDate.value=collectionDate;
//    agentId.value=agentId;
//    OPtremittance.value=
//this.c.TransDate=this.datepipe.transform(this.c.TransDate,"yyyy-MM-dd");
//this.c.CollectionDate=this.datepipe.transform(this.c.CollectionDate,"yyyy-MM-dd");

    this.data = this.service.getAgentCollectionDetailsGrid(this.c);
    this.data.subscribe(
      (response: any) => {
        this.agentcollectiondetailslist = response;

        console.log(this.agentcollectiondetailslist);

        for(let i=0;i<this.agentcollectiondetailslist.length;i++)
        {
          debugger;
          this.agentcollectiondetailslist[i].paidamt=this.agentcollectiondetailslist[i].paid==null||undefined?0:this.agentcollectiondetailslist[i].paid;
          LBLADJAMT = (+LBLADJAMT) + (+paid);
          toatl=(+this.agentcollectiondetailslist[i].col)-(+paid);      
          this.agentcollectiondetailslist[i].Total=toatl//total
          txtamt=(+txtamt)+(+this.agentcollectiondetailslist[i].col);
          this.agentcollectiondetailslist[i].Balance=txtamt;//bal
        }
        this.c.TotalcollectionDep=txtamt;
        this.c.Totalcollectionsusp=LBLADJAMT;
        
        this.calculateint(txtamt,depint);
      //   paidAmt = IIf(IsNull(rss!prin), 0, rss!prin)

      //   LBLADJAMT = val(LBLADJAMT) + paidAmt
      //   msfPigmy.TextMatrix(msfPigmy.Rows - 1, 3) = RSAGENT!trans_amt - paidAmt   ''total
      //   lstMonth.AddItem RSAGENT!trans_date & Space(5) & RSAGENT!trans_amt
      //   txtamt = val(txtamt) + RSAGENT!trans_amt
      //   msfPigmy.TextMatrix(msfPigmy.Rows - 1, 4) = txtamt         
      // //  this.c.TotalcollectionDep=this.agentcollectiondetailslist.Balance;
      //  console.log("totaldepo",this.c.TotalcollectionDep);


      //  for(let i=0;i<this.agentcollectiondetailslist.length;i++)
      //  {
      //    if(i=0)
      //    {
      //      this.agentcollectiondetailslist[i].Balance=this.agentcollectiondetailslist[i].Coll;
      //    }
      //  }
      //Available amount
      //this.c.AvailableAmt=((this.c.DepositCommission/100)*this.c.TotalcollectionDep);
      //this.c.Amount=this.c.AvailableAmt;

        console.log(this.agentcollectiondetailslist);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });

  }

  
  //GetDailyCollectiongrid
  GetDailyCollectionDetailsGrid(agentid,trans_Date)
  { 
    let total=0;
    debugger;
    this.TotalDailycollection=0;
    //transdateee=this.datepipe.transform(trans_Date,"yyyy-MM-dd");
    this.data = this.service.getDailyCollectionDetailsGrid(agentid,trans_Date);
    this.data.subscribe(
      (response: any) => {
        this.dailycollectiondetailslist = response;
        
        console.log("responsedata");
        console.log(this.dailycollectiondetailslist);

        for(let i=0;i<this.dailycollectiondetailslist.length;i++)
        {
          if(this.dailycollectiondetailslist[i].Date!=null)
          this.dailycollectiondetailslist[i].Date=((this.dailycollectiondetailslist[i].Date).split('T'))[0];
        //   if(this.dailycollectiondetailslist[i].PaidOn!=null)
        //   this.dailycollectiondetailslist[i].PaidOn=((this.dailycollectiondetailslist[i].PaidOn).split('T'))[0];

        //  // 

        //   this.TotalDailycollection=this.TotalDailycollection+this.dailycollectiondetailslist[i].Amount;
        //   console.log("later data");
        //   console.log(this.TotalDailycollection);
              total=(+total)+(+this.dailycollectiondetailslist[i].Amount);
        }
        this.TotalDailycollection=total;
        console.log(this.dailycollectiondetailslist);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
    }

    getac(DepNo:string)
    {
        this.c=DepNo;
    }

      //agentDetails
      //  GetAgentdetails(agentId)
      //  {
      //    debugger;
      // this.data = this.service.getDailyCollectionDetailsGrid(this.c.AGENT_ID,trans_Date);
      // this.data.subscribe(
      //  (response: any) => {
      //    this.dailycollectiondetailslist = response;
      //    console.log(this.dailycollectiondetailslist);
      //  }, (error) => {
      //    document.getElementById('loader-spinner').style.display = "none";
      //    this.errorHandler.handleError(error);
      //  });
      //  }


    onSubmit(pigmymonthlytransfer: NgForm) {
      debugger;
      if(this.c.AGENT_ID==undefined|| null)
        {
          swal('Agent','Select agent','warning');
        }
     else if(!pigmymonthlytransfer)
      {
        swal('Mandatory','Enter Mandatory fields','warning')
      }
      else
      {
      pigmymonthlytransfer.value.frmname="frmPigmyAgentDetail";
      pigmymonthlytransfer.value.tag="";
      pigmymonthlytransfer.value.DepositCommission=3;

      //if (!pigmymonthlytransfer.invalid) {
        document.getElementById('loader-spinner').style.display = "block";
        console.log(pigmymonthlytransfer.value);
        this.data = this.service.SavePigmyDetails(pigmymonthlytransfer.value);
        this.data.subscribe(
          (response) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Success!', 'Saved Successfully.', 'success');
            pigmymonthlytransfer.reset();
            this.agentcollectiondetailslist=[];
            this.dailycollectiondetailslist=[];
            this.TotalDailycollection="";
          }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
             this.errorHandler.handleError(error);
          });
      //}
      // else {
      //   document.getElementById('loader-spinner').style.display = "none";
      //   swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
      // }
      }
    }

    transfermonthly(pigmymonthtran)
    {
      debugger;
      
      document.getElementById('loader-spinner').style.display = "block";
      this.transfrdata=this.service.transfermonthly(pigmymonthtran);
      this.transfrdata.subscribe(
        (response:any)=>
        {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Transfered!', 'Transfered'+response, 'success');
          // this.pigmymonthlytransfer.reset();
          // this.agentcollectiondetailslist=[];
          // this.dailycollectiondetailslist=[];
          // this.TotalDailycollection="";

          // this.c={};
          // this.agentcollectiondetailslist=[];
          // this.dailycollectiondetailslist=[];
          // this.TotalDailycollection="";
        },
        (error) => {
          document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.handleError(error);
         }
      )


    }
    AGENT_IDempty:boolean=false;
    Agentselect(agntid,trans_Date,collectionDate,OPtremittance,depint)
    {
      if(agntid==undefined||null)
        this.AGENT_IDempty=true;
      else
        this.AGENT_IDempty=false;
      this.GetAgentCollectionDetailsGrid(agntid,trans_Date,collectionDate,OPtremittance,depint);

    }

    calculateint(txtamt:number,txtPerc:number )
    {
      let cramt;
      // if(chckround==false)

        cramt = (txtamt) * (txtPerc) / 100; //+ (val(TxtAmtLn) * (val(txtPercLn) / 100)))

    // Else
    //      cramt = Round((val(txtamt) * (val(txtPerc) / 100)) + (val(TxtAmtLn) * (val(txtPercLn) / 100)), 2)

    // End If
   // Label10.Caption = (val(txtamt) * (val(txtPerc) / 100) & " + " & (val(TxtAmtLn)) * (val(txtPercLn) / 100))
    this.c.AvailableAmt = cramt;
    this.c.Amount=cramt;
    }

}



// WEBPACK FOOTER //
// ./src/app/othertransaction/pigmy-monthly-transfer/pigmy-monthly-transfer.component.ts